import { AxiosResponse } from "axios";
import { APIS } from "../api/apis";
import { get, getAxiosHeaders, post } from "./AxiosAPI";
import { AttendanceDTO } from "./types";
import { getLoginId } from "../user/UserService";

export const submitAttendanceToServer = (attendances: AttendanceDTO[]): Promise<AxiosResponse> => {
  console.log("Entering submitAttendanceToServer");
  const currHeaders = getAxiosHeaders();
  currHeaders.set("facultyUserName", getLoginId());
  console.log("Calling post");
  let response: Promise<AxiosResponse> = post(APIS.ATTENDANCES, currHeaders, attendances);
  return response;
};

export async function getStudentsForAttendanceByGradeAndSection(grade: string, section: string, dayOfAttendance: string): Promise<AxiosResponse> {
  console.log("In getStudentsByGradeAndSection:: grade: " + grade + " section: " + section);
  const currHeaders = getAxiosHeaders();
  console.log("Updating grade, section value in URL ");
  let url = APIS.GET_STUDENTS_FOR_ATTENDANCE_BY_GRADE_AND_SECTION.replace("grade_value", grade).replace("section_value", section);
  console.log("Final URL with grade, section and term: " + url);
  return get(url, currHeaders);
}

export interface AttendanceFilter {
  grade: string;
  section: string;
  attendanceDate?: string;
  facultyLoginId: string;
  data?: AttendanceDTO[];
}

export const openSession = async (filter: AttendanceFilter) => {
  const query = new URLSearchParams({
    grade: filter.grade,
    section: filter.section
  });
  let aHeaders = getAxiosHeaders();
  aHeaders.set("facultyLoginId", filter.facultyLoginId);
  return await get(`/attendances/session/open?${query.toString()}`, aHeaders);
};

export const submitAttendnace = async (filter: AttendanceFilter) => {
  const query = new URLSearchParams({
    grade: filter.grade,
    section: filter.section,
    facultyLoginId: filter.facultyLoginId
  });
  let aHeaders = getAxiosHeaders();
  aHeaders.set("facultyLoginId", filter.facultyLoginId);
  return await post(`/attendances/session/submit?${query.toString()}`, aHeaders, filter.data);
};

export interface AttendanceReportFilter {
  grade: string;
  section: string;
  month: string;
  year: string;
  reportType: string;
}

export const getAttendanceReport = async (filter: AttendanceReportFilter) => {
  const query = new URLSearchParams({
    grade: filter.grade,
    section: filter.section,
    month: filter.month,
    year: filter.year,
    reportType: filter.reportType
  });
  let aHeaders = getAxiosHeaders();
  return await get(`/attendances/reports?${query.toString()}`, aHeaders);
};

export type MessageStatus = "PENDING" | "SENT" | "FAILED" | "SKIPPED";

/** One row of the Message Status tab: an Absent / Late student and their parent's SMS status. */
export interface AttendanceMessageStatusDTO {
  attendanceId: number;
  admissionNo: string;
  studentName: string;
  guardianMobileNo?: number;
  attendance: "Absent" | "Late";
  messageStatus: MessageStatus;
  failureReason?: string;
  attemptCount: number;
  lastAttemptAt?: string;
}

export interface AttendanceMessagesResponse {
  /** Retry is only allowed while sending is on (same rule as the backend) */
  messageSendingEnabled: boolean;
  messages: AttendanceMessageStatusDTO[];
}

export interface RetryMessagesResponse {
  queued: number;
  ignored: number;
}

/** @param date yyyy-MM-dd */
export const getAttendanceMessages = async (grade: string, section: string, date: string): Promise<AxiosResponse<AttendanceMessagesResponse>> => {
  const query = new URLSearchParams({ grade, section, date });
  return await get(`/attendances/messages?${query.toString()}`, getAxiosHeaders());
};

export const retryAttendanceMessages = async (grade: string, section: string, attendanceIds: number[]): Promise<AxiosResponse<RetryMessagesResponse>> => {
  const query = new URLSearchParams({ grade, section });
  return await post(`/attendances/messages/retry?${query.toString()}`, getAxiosHeaders(), { attendanceIds });
};
